<template>
  <div id="app_top_part_outer" class="container-fluid">
      <div class="col-xs-10" id="top_part_left">
        <a href="/" style="margin-left: 2.1vw;" >
          <img id="top_part_logo" src="../assets/shl_menu_logo.png">
        </a>
        <img id="top_part_vertical_line" src="../assets/shl_top_part_vertical_line.png">
        <div id="top_part_desc">{{whiteItem.desc}}<span>{{whiteItem.desc_en}}</span></div>
      </div>
      <div class="col-xs-2" id="top_part_right">
        <a href="javascript:void(0);" @click="goBack">返回</a>
        <span v-if="showExitButton" style="color: white;">|</span>
        <a v-if="showExitButton" href="javascript:void(0);"  @click="loginOut">退出</a>
      </div>

  </div>
</template>

<script>
export default {
  name: "AppTopPart",
  props: [
    'whiteItem'
  ],
  data() {
    return {
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      let user = this.$store.state.dataStore.getUser();
      if (user == null) {
        return null;
      }
      return user.token;
    },
    showExitButton() {
      let token = this.user;
      if (token == null || token.length == 0) {
        return false;
      } else {
        return true;
      }
    }
  },

  watch: {

  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'homePage',
      });
    },
    loginOut() {
      let _this = this;
      this.$store.state.http.ajax.userSignOut(function (data) {
        _this.reLogin();
      }, function (data) {
        _this.reLogin();
      });
    },
    reLogin() {
      this.$toast('退出成功！');
      this.$router.push({
        name: 'loginPage',
      });
    }
  }
}
</script>

<style scoped>
  #app_top_part_outer {
    background: #e71a34 url("../assets/shl_app_top_bg.png") no-repeat center top;
    background-size: auto 100%;
    height: 9.7273vw;
    max-height: 132px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    /*padding-left: 15px;*/
    /*padding-right: 15px;*/
  }

  @media screen and (min-width: 375px){
    /*#app_top_part_outer {*/
    /*  padding-left: 10vw;*/
    /*  padding-right: 10vw;*/
    /*}*/
  }

  @media screen and (min-width: 800px){
    /*#app_top_part_outer {*/
    /*  padding-left: 17.5vw;*/
    /*  padding-right: 17.5vw;*/
    /*}*/
  }

  @media screen and (min-width: 1200px){
    /*#app_top_part_outer {*/
    /*  padding-left: 16.2vw;*/
    /*  padding-right: 16.2vw;*/
    /*}*/
  }

  @media screen and (min-width: 1375px){
    /*#app_top_part_outer {*/
    /*  padding-left: 220px;*/
    /*  padding-right: 220px;*/
    /*}*/
  }

  #top_part_left {
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  #top_part_logo {
    height: 7.51vw;
    max-height: 90px;
    width: auto;
  }

  #top_part_vertical_line {
    width: 2px;
    height: 2.5vw;
    margin-left: 2vw;
  }

  #top_part_desc {
    margin-left: 2vw;
    font-size: 1.5rem;
    color: white;
    font-weight: bold;
    letter-spacing: 3px;
    /*min-width: 100px;*/
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  #top_part_desc > span {
    font-weight: normal;
    margin-left: 5px;
    letter-spacing: 1.5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media screen and (max-width: 530px){
    #top_part_vertical_line {
      display: none;
    }
    #top_part_desc {
      display: none;
    }
  }

  #top_part_right {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-left: 15px;
    margin-right: 15px;
  }

  #top_part_right > a {
    color: white;
    text-decoration: none;
    text-align: center;
    vertical-align: middle;
    line-height: 30px;
    min-width: 50px;
    height: 30px;
    font-size: 1.5rem;
    font-weight: bold;
  }

  #top_part_right > a:hover {
    color: #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppTopPart.vue